import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import VModal from "vue-js-modal";
import Vuex from "vuex";
import { Config } from "./config/index";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@fortawesome/fontawesome-free/css/all.css";
// import '@fortawesome/fontawesome-free/js/all.js'

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "FontAwesomeIcon";
import VueCarousel from "vue-carousel";
import VueSelectImage from "vue-select-image";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import { EmojiPickerPlugin } from "vue-emoji-picker";
import HighchartsVue from "highcharts-vue";
import WorldCloud from "highcharts/modules/wordcloud";
import Highcharts from "highcharts";
// require('./assets/css/custom.css');

import ToggleButton from "vue-js-toggle-button";

Vue.use(ToggleButton);

import ScrollLoader from "vue-scroll-loader";

Vue.use(ScrollLoader);

import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)

import CryptoJS from "crypto-js";
Vue.use(CryptoJS)



Vue.use(EmojiPickerPlugin);
// Vue.forceUpdate();
import BusinessHours from "vue-business-hours";

WorldCloud(Highcharts);

Vue.use(BusinessHours);
Vue.use(HighchartsVue);

import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);

import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme);

// import "mdbvue/build/css/mdb.css";
import JwPagination from "jw-vue-pagination";
import moment from "moment";

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY HH:MM:SS");
  }
});

Vue.filter("formatDateonly", function(value) {
  if (value) {
    return moment(String(value)).format("YYYY/MM/DD");
  }
});

import "vue-datetime/dist/vue-datetime.css";
require("vue-select-image/dist/vue-select-image.css");
require("babel-core/register");
require("babel-polyfill");

library.add(faUserSecret);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.component("jw-pagination", JwPagination);

axios.defaults.baseURL = Config.path;
axios.defaults.db = Config.db;

Vue.config.silent = true

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(router);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
// Vue.use(Vuex);

Vue.prototype.$log = console.log.bind(console);
Vue.prototype.$http = axios;

const session_id = localStorage.getItem("session_id");
const token = localStorage.getItem("token");

if (session_id) {
  Vue.prototype.$http.defaults.withCredentials = true;
}
if (token) {
  Vue.prototype.$http.defaults.headers.common["token"] = token;
}

new Vue({
  el: "#app",
  router,
  store,
  icons,
  FontAwesomeIcon,
  EmojiPickerPlugin,
  template: "<App/>",
  components: {
    App,
  },
});
